// Login.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
// import "../css/login.css";s
import logo from "../images/hosming_rojo.jpg";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { ApiService } from "../components/ApiService";
import { ModalNewPassword } from "../components/ModalNewPassword";
import { ModalRegistroRepeat } from "../components/ModalRegistroRepeat";
import { useProovedorData } from '../components';

// Importar toast
import { toast } from "react-toastify";

export const Login = ({ onSwitchToRegister }) => {
  const [email_User, setEmailUser] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const [openModalNewPassword, setOpenModalNewPassword] = useState(false);
  const [openModalVerify, setOpenModalVerify] = useState(false);

  const [loginState, setLoginState] = useState(false);

  const navigate = useNavigate();
  const { shareDetected, setShareDetected } = useProovedorData() ?? [];


  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    const camposVacios = [];

    if (!email_User.trim()) camposVacios.push("Email");
    if (!password.trim()) camposVacios.push("Contraseña");

    if (camposVacios.length === 2) {
      toast.error("Debes ingresar el Email y la Contraseña");
      newErrors.email_User = "*";
      newErrors.password = "*";
      isValid = false;
    } else if (camposVacios.length === 1) {
      const campoFaltante = camposVacios[0];
      toast.error(`El campo ${campoFaltante} es obligatorio`);
      if (campoFaltante === "Email") newErrors.email_User = "*";
      if (campoFaltante === "Contraseña") newErrors.password = "*";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Al enviar el formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    let userData = {
      email_User: email_User.toLowerCase(),
      origin: window.origin ?? 'https://hosming.com',
      password,
      password_confirmation: password
    };

    try {
      setLoginState(true);

      const response = await ApiService.fetchData("api/auth/login", {
        method: "POST",
        body: JSON.stringify(userData),
      });

      if (response?.access_token) {
        localStorage.setItem("token", response.access_token);
        localStorage.setItem("name", response.user.fullname);
        localStorage.setItem("profileImage", response.user.profile);

        if (response?.shared_data == null) navigate("/");
        else {
          navigate("/send-access");
        }
      }

      if (response?.code === 403) setOpenModalVerify(true);
    } catch (error) {
      toast.error("Error en la conexión, intente de nuevo");
    } finally {
      setLoginState(false);
    }
  };

  //real: https://bohfis.com/

  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.message && event?.data?.origin) {
        sessionStorage.setItem('extracted_data', JSON.stringify({ origin: event?.data?.origin }));
        setShareDetected({ origin: event?.data?.origin });
      }
    };

    // Escuchar mensaje de la principal
    window.addEventListener('message', handleMessage);

    if (window.opener) window.opener.postMessage("I'm ready", '*');

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css?family=Lato:300,400,700,900&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
        />
      </Helmet>

      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
              <div className="wrap d-md-flex">
                {/* Columna izquierda (roja) */}
                <div
                  className="text-wrap p-4 p-lg-5 text-center d-flex align-items-center order-md-last"
                  style={{ background: "#a10302" }}
                >
                  <div className="text w-100">
                    <img src={logo} alt="logo" className="img-logo" />
                    <h2>Bienvenido(a)</h2>
                    {
                      Object.keys(shareDetected) == 0 && (<>
                        <p>¿No tienes una cuenta?</p>
                        <button
                          type="button"
                          className="btn btn-white btn-outline-white"
                          onClick={onSwitchToRegister}
                        >
                          Crea una cuenta
                        </button>
                      </>)
                    }
                  </div>
                </div>

                {/* Columna derecha (form login) */}
                <div className="login-wrap p-4 p-lg-5">
                  <h3
                    className="mb-4"
                    style={{ textAlign: "left", fontWeight: "500" }}
                  >
                    Iniciar Sesión
                  </h3>
                  <form onSubmit={handleSubmit} className="signin-form">
                    {/* Email */}
                    <div className="form-group mb-3">
                      <label className="label" htmlFor="email_User">
                        Email
                      </label>
                      {errors.email_User && (
                        <span style={{ color: "red" }}>{errors.email_User}</span>
                      )}
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        value={email_User}
                        onChange={(e) => setEmailUser(e.target.value)}
                        autoComplete="on"
                      />
                    </div>

                    {/* Contraseña */}
                    <div
                      className="form-group mb-3"
                      style={{ position: "relative" }}
                    >
                      <label className="label" htmlFor="password">
                        Contraseña
                      </label>
                      {errors.password && (
                        <span style={{ color: "red" }}>{errors.password}</span>
                      )}
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{ paddingRight: "45px" }}
                        autoComplete="off"
                      />
                      <span
                        onClick={handleTogglePassword}
                        style={{
                          position: "absolute",
                          top: "65%",
                          right: "15px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#a10302",
                        }}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </span>
                    </div>

                    <div className="form-group">
                      <button
                        type="submit"
                        className="form-control btn btn-primary submit px-3 custom-btn"
                        style={{ background: "#a11d1c", marginTop: "30px", opacity: loginState ? '0.7' : '1' }}
                        disabled={loginState}
                      >
                        {loginState ? 'Ingresando...' : 'Ingresar'}
                      </button>
                    </div>

                    <div className="form-group d-md-flex">
                      <div className="w-100 text-left">
                        <button
                          type="button"
                          style={{
                            background: "transparent",
                            border: "none",
                            textDecoration: "underline",
                            color: '#000'
                          }}
                          id="olvido-password"
                          onClick={() => setOpenModalNewPassword(true)}
                        >
                          Olvidaste tu contraseña?
                        </button>

                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal para Nueva Contraseña */}
      <ModalNewPassword
        open={openModalNewPassword}
        onClose={() => setOpenModalNewPassword(false)}
      />

      {/* Modal para verificar cuenta no validada */}
      <ModalRegistroRepeat
        open={openModalVerify}
        onClose={() => setOpenModalVerify(false)}
        email={email_User}
        onVerified={() => {
          toast.success("Cuenta verificada, ya puedes iniciar sesión");
        }}
      />
    </>
  );
};
